/*
 * File: api.module.ts                                                         *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 7th December 2022 12:22:26                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Wednesday, 7th December 2022 13:44:45                        *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CSP_NONCE, NgModule } from '@angular/core';
// import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { MenusModule } from '../menus/menus.module';
import { BackupsListComponent } from './components/backups-list/backups-list.component';
import { DropboxComponent } from './components/dropbox/dropbox.component';
import { TableModule } from 'primeng/table';
import { FormatFileSize } from './pipes/format-filesize';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import { CardModule } from 'primeng/card';


@NgModule({
  imports: [
    BrowserModule,
    MenusModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    ConfirmDialogModule,
    MessageModule,
    MessagesModule,
    CardModule,
  ],
  declarations: [BackupsListComponent, DropboxComponent, FormatFileSize],
  exports: [BackupsListComponent, DropboxComponent],
  providers: [],
})
export class BackupModule {}
